import { Box } from 'edenred-ui';
import styled from 'styled-components';

interface StyledActionBoxProps {
  isGroupManagementAllowed: boolean;
}

export const StyledActionBox = styled(Box)<StyledActionBoxProps>`
  background-color: ${({ isGroupManagementAllowed, theme }) =>
    isGroupManagementAllowed ? theme.lightBlue5 : theme.warningBackgroundColor};
  border: 1px solid
    ${({ isGroupManagementAllowed, theme }) =>
      isGroupManagementAllowed
        ? theme.primaryBackColorLight20
        : theme.warningColor};
`;
